var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.formSubmitted($event)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Transaction Type*",
                        "label-for": "trxType",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "trxType",
                          name: "trxType",
                          options: _vm.typesDLL,
                        },
                        model: {
                          value: _vm.transaction.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.transaction, "type", $$v)
                          },
                          expression: "transaction.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Transaction Date*",
                        "label-for": "trxDate",
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "mb-1",
                        attrs: { id: "trxDate" },
                        model: {
                          value: _vm.transaction.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.transaction, "date", $$v)
                          },
                          expression: "transaction.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showFromWarehouse
                ? _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "From Warehouse*",
                            "label-for": "fromWarehouse",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                id: "fromWarehouse",
                                name: "fromWarehouse",
                                options: _vm.warehouses,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.transaction.fromWarehouse,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.transaction,
                                    "fromWarehouse",
                                    $$v
                                  )
                                },
                                expression: "transaction.fromWarehouse",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("None"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showToWarehouse
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "To Warehouse",
                            "label-for": "toWarehouse",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                id: "toWarehouse",
                                name: "toWarehouse",
                                options: _vm.warehouses,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.transaction.toWarehouse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.transaction, "toWarehouse", $$v)
                                },
                                expression: "transaction.toWarehouse",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("None"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-col",
                { staticClass: "mb-2", attrs: { cols: "12" } },
                [
                  _c("label", { attrs: { for: "trxRef" } }, [
                    _vm._v("Transaction Reference"),
                  ]),
                  _c("b-form-textarea", {
                    attrs: {
                      id: "trxRef",
                      name: "trxRef",
                      placeholder: "Transaction Reference",
                      rows: "3",
                    },
                    model: {
                      value: _vm.transaction.refNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.transaction, "refNo", $$v)
                      },
                      expression: "transaction.refNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-form",
        {
          ref: "form",
          staticClass: "repeater-form",
          style: { height: _vm.trHeight },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.addLine($event)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: "Enter Barcode" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addItemWithBarcode($event)
                          },
                        },
                        model: {
                          value: _vm.barcode,
                          callback: function ($$v) {
                            _vm.barcode = $$v
                          },
                          expression: "barcode",
                        },
                      }),
                      _c(
                        "b-input-group-append",
                        { attrs: { "is-text": "" } },
                        [_c("feather-icon", { attrs: { icon: "CastIcon" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        id: "modal-barcode",
                        title: "Select Product",
                        "ok-only": "",
                        "ok-title": "Cancel",
                        centered: "",
                      },
                    },
                    _vm._l(_vm.selectedProduct, function (product, index) {
                      return _c(
                        "b-row",
                        { key: product.id, staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "8" } },
                            [
                              _c("b-card-text", { staticClass: "mb-0" }, [
                                _vm._v(_vm._s(product.name)),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "text-right", attrs: { cols: "4" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addProductFromModal(product.id)
                                    },
                                  },
                                },
                                [_vm._v("Select")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-row", [_c("b-col", { attrs: { cols: "12" } }, [_c("hr")])], 1),
          _vm._l(
            _vm.transaction.inventoryTransactionLine,
            function (item, index) {
              return _c(
                "b-row",
                {
                  key: item.serial,
                  ref: "row",
                  refInFor: true,
                  attrs: { id: item.serial },
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Product / Raw Material*",
                            "label-for": "itemId",
                          },
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "itemId",
                              options: _vm.filteredItems,
                              label: "name",
                              placeholder: "Search Product / Raw Material",
                            },
                            on: {
                              search: _vm.filterItems,
                              input: function ($event) {
                                return _vm.itemChanged(item)
                              },
                            },
                            model: {
                              value: item.itemId,
                              callback: function ($$v) {
                                _vm.$set(item, "itemId", $$v)
                              },
                              expression: "item.itemId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Qty*", "label-for": "itemQty" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "itemQty",
                              name: "itemQty",
                              type: "number",
                              required: "",
                              min: "1",
                              max: "100",
                              placeholder: "",
                            },
                            model: {
                              value: item.qty,
                              callback: function ($$v) {
                                _vm.$set(item, "qty", $$v)
                              },
                              expression: "item.qty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-50", attrs: { lg: "3", md: "3" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(234, 84, 85, 0.15)",
                              expression: "'rgba(234, 84, 85, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mt-0 mt-md-2",
                          attrs: { variant: "outline-danger" },
                          on: {
                            click: function ($event) {
                              return _vm.removeLine(index)
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25",
                            attrs: { icon: "XIcon" },
                          }),
                          _c("span", [_vm._v("Delete")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                ],
                1
              )
            }
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      attrs: {
                        variant: "primary",
                        disabled:
                          _vm.loading ||
                          _vm.productLoading ||
                          _vm.materialLoading ||
                          _vm.uomLoading ||
                          _vm.warehouseLoading,
                      },
                      on: { click: _vm.addLine },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-25",
                        attrs: { icon: "PlusIcon" },
                      }),
                      _c("span", [_vm._v("Add Line")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticStyle: { "text-align": "right" }, attrs: { cols: "12" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addTransaction()
                    },
                  },
                },
                [
                  _vm.loading ||
                  _vm.productLoading ||
                  _vm.materialLoading ||
                  _vm.uomLoading ||
                  _vm.warehouseLoading
                    ? _c("b-spinner", {
                        staticClass: "mx-2",
                        attrs: { small: "" },
                      })
                    : _vm._e(),
                  _vm._v("Save and Post"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }